import { BACKEND_BASE_URL } from 'src/constants/ApiRoutes';
import { HANA_API_DOMAIN, axiosInstance } from 'src/constants/axiosInstance';

export const isBackendAxiosRequest = (params: {
  requestUrl: string;
  baseUrl?: string;
}): boolean => {
  const currentOrigin = window.location.origin;

  const resolvedBackendBaseUrl =
    typeof BACKEND_BASE_URL === 'string' && BACKEND_BASE_URL.length > 0
      ? BACKEND_BASE_URL
      : typeof axiosInstance.defaults.baseURL === 'string' &&
          axiosInstance.defaults.baseURL.length > 0
        ? axiosInstance.defaults.baseURL
        : currentOrigin;

  try {
    const backendHostname = new URL(resolvedBackendBaseUrl, currentOrigin)
      .hostname;
    const requestHostname = new URL(
      params.requestUrl,
      params.baseUrl ?? currentOrigin,
    ).hostname;

    return (
      requestHostname === backendHostname || requestHostname === HANA_API_DOMAIN
    );
  } catch (error) {
    return false;
  }
};
